module.exports = __webpack_public_path__ + "img/react-logo.8e26f220.svg";